import React from "react";

function VerticalLine({ height }) {
  return <div className="vertical-line" style={{ height: height }}></div>;
}

export default VerticalLine;
